const _ = require('lodash');

const COPY_FNS = ['map', 'filter', 'slice', 'concat'];
let inOp;

const copyProps = (dst, src) => {
	Object.keys(src)
		.filter((k) => parseInt(k, 10).toString() !== k || k === 'NaN')
		.forEach((k) => {
			dst[k] = src[k];
		});
};

/** Extend from this class to get an Array object with custom functionality/fields that is preserved in copies
 * of the array created with .filter/map etc. Example:
 *
 * class ExampleArray extends ArrayWithExtraFields {
 * 	  onConstructed(id, dims) { // use instead of constructor(...)
 *     	 this.id = id;
 *       this.setElements(dims);
 *     }
 * }
 * ...
 * x = new ExampleArray('test', [1,2,3])
 *   => ExampleArray(3) [1, 2, 3, id: 'test']
 * x.map((e) => e*2)
 *   => ExampleArray(3) [2, 4, 6, id: 'test']
 */
class ArrayWithExtraFields extends Array {
	constructor(...args) {
		if (inOp) {
			super(...args);
		} else if (args[0] instanceof ArrayWithExtraFields) {
			super(...args);
			copyProps(this, args[0]);
		} else {
			super();
			this.onConstructed?.(...args);
		}
	}

	[Symbol.iterator]() {
		return super.values();
	}

	setElements(arr) {
		this.length = 0;
		this.push(...(arr || []));
	}
}

Object.assign(ArrayWithExtraFields.prototype, _.mapValues(_.keyBy(COPY_FNS), (fn) => function (...args) {
	try {
		inOp = true;
		const res = Array.prototype[fn].call(this, ...args);
		copyProps(res, this);
		return res;
	} finally {
		inOp = false;
	}
}));

module.exports = ArrayWithExtraFields;
